import React from 'react';
import { Integration } from '@carbon/pictograms-react';
import { EmptyState } from 'components/EmptyState';

const EmptyStatePage = () => {
  return (
    <EmptyState>
      <div className="search-webhook-no-data--wrapper">
        <Integration className="logo" />
        <div className="search-webhook-empty-state-heading">
          There is no data to display
        </div>
        <div className="search-webhook-empty-state-sub-heading">
          Try different filter options
        </div>
      </div>
    </EmptyState>
  );
};

EmptyStatePage.displayName = 'EmptyStatePage';
export default EmptyStatePage;
